'use client';

import { ComponentProps } from 'react';
import { Link } from '@/shared/i18n/navigation';
import { cn } from '@/shared/lib/cn';
import { BottomPanelTabProps } from './types';

export const BottomPanelTab = ({
    icon,
    title,
    isIconVisible = true,
    isTitleVisible = true,
    isActive = false,
    href,
    ...props
}: BottomPanelTabProps) => {
    const content = (
        <>
            {isIconVisible && icon && icon}
            {isTitleVisible && title && <span className="bottom-panel__tab-title">{title}</span>}
        </>
    );

    return (
        <div className={cn('bottom-panel__tab', isActive && 'bottom-panel__tab--active')}>
            {href ? (
                <Link
                    className="bottom-panel__tab-link"
                    href={href}
                    title={title}
                    {...(props as Partial<ComponentProps<typeof Link>>)}
                >
                    {content}
                </Link>
            ) : (
                <button className="bottom-panel__tab-link" type="button" title={title}>
                    {content}
                </button>
            )}
        </div>
    );
};
